"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Button(_ref) {
  var className = _ref.className,
      color = _ref.color,
      variation = _ref.variation,
      children = _ref.children,
      onClick = _ref.onClick,
      cypressName = _ref.cypressName;
  return _react["default"].createElement(_pclnDesignSystem.Button, {
    className: className,
    color: color,
    variation: variation,
    onClick: onClick,
    "data-cy": cypressName
  }, children);
}

Button.displayName = 'Button';
Button.propTypes = {
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  variation: _propTypes["default"].oneOf(['fill', 'outline']),
  children: _propTypes["default"].node,
  onClick: _propTypes["default"].func,
  cypressName: _propTypes["default"].string
};
Button.defaultProps = {
  className: '',
  cypressName: 'button'
};

var _default = (0, _react.memo)(Button);

exports["default"] = _default;